import {call, put} from 'redux-saga/effects';
import {clientQuery} from 'Core/data/GraphQLApi';
import {endpoints} from 'Core/defaultValues';
import {ExceptionManager} from 'Core/logManager';
// Actions
import {reportsMainGenerateReportProgress} from 'Redux/actions';

import {getTimeZone} from 'Modules/reports/views/main/components/reportsTab/helper';

function* getLandmarkEngineHoursDetailsReport(report, event) {
    const {timeZone, name, reportTimeRanges} = report;
    const {startRange, endRange} = report.filters;
    const {
        filterType,
        filterArray,
        page,
        rowsPerPage,
        sortField,
        sortOrder,
        otherFilters
    } = event.filters;
    try {
        const newReport = JSON.parse(JSON.stringify(report))

        let data = yield call(
            clientQuery,
            `query getLandmarkEngineHoursDetailsReport ($conditions: ReportConditionsInput, $limit: Int, $offset: Int) {
              Report: getLandmarkEngineHoursDetailsReport (conditions: $conditions, limit: $limit, offset: $offset) {
                items {
                    id
                    idLabel
                    date
                    landmarkId
                    landmarkName
                    groupId
                    groupIdLabel
                    totalVisits
                    totalVisitsDuration
                    engineHours
                }
                total
                limit
                offset
                category
              }
            }`,
            {
                "conditions": {
                    reportName: 'LandmarkEngineHours',
                    category: {
                        field: filterType,
                        entities: [
                            {
                                id: filterArray?.id,
                                type: filterType === 'deviceId' ? 'Unit' : 'Driver',
                                parentId: filterArray?.groupId
                            }
                        ]
                    },
                    timeZone: getTimeZone(timeZone),
                    dateRange: {
                        fields: [
                            "unitTime"
                        ],
                        GTE: startRange,
                        LTE: endRange,
                        reportTimeRanges
                    },
                    sortField: {
                        field: sortField || "deviceId",
                        order: sortOrder === 'desc' ? 'DESC' : 'ASC'
                    },
                },
                limit: rowsPerPage,
                offset: page
            },
            endpoints.GRAPHQL_PX_REPORTING
        );
        if (data && data.Report) {
            newReport.summary = data.Report
            newReport.loadingSummary = false
            yield put(reportsMainGenerateReportProgress(newReport))
        } else {
            newReport.loadingSummary = false
            yield put(reportsMainGenerateReportProgress(newReport))
        }
    } catch (exc) {
        report.loadingSummary = false
        ExceptionManager(exc, '/reports/landmarkEngineHoursDetailsReport', 'getLandmarkEngineHoursDetailsReport');
        yield put(reportsMainGenerateReportProgress(report))
    }
}

export default getLandmarkEngineHoursDetailsReport;
